import { CategoryIcon } from '@modules/common/components/CategoryIcon';
import { TRACKED_KEYWORD } from '@modules/common/constants';
import { Category } from '@modules/common/types';
import { getCategoryColorFromTheme } from '@modules/common/utils';
import { useIsFeedbackRedesignEnabled } from '@modules/feedbackV2/common/hooks';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Stack, Tooltip, Typography } from '@mui/material';
import { capitalize } from 'lodash';
import pluralize from 'pluralize';
import { FeedbackLabelListProps } from '../FeedbackLabelList/FeedbackLabelList';

interface FeedbackCategoryDetailedViewProps {
  category: Category;
  isEditPredictionsMode: boolean;
  renderFeedbackLabelList: (
    props?: Partial<FeedbackLabelListProps>,
  ) => JSX.Element;
}

export const FeedbackCategoryDetailedView = ({
  category,
  isEditPredictionsMode,
  renderFeedbackLabelList,
}: FeedbackCategoryDetailedViewProps) => {
  const isFeedbackRedesignEnabled = useIsFeedbackRedesignEnabled();

  return (
    <Stack spacing={1}>
      <Stack
        direction="row"
        spacing={isFeedbackRedesignEnabled ? 1.35 : 0.5}
        alignItems="center"
        pl={isFeedbackRedesignEnabled ? 1.9 : 0}
      >
        <CategoryIcon category={category} size={14} />
        <Typography
          variant="body2"
          fontWeight={isFeedbackRedesignEnabled ? 'bold' : 'normal'}
          sx={{
            color: (theme) =>
              isFeedbackRedesignEnabled
                ? getCategoryColorFromTheme({
                    theme,
                    category,
                  })
                : undefined,
          }}
        >
          {capitalize(category)}
        </Typography>
        {category === Category.Uncategorized && (
          <Tooltip
            title={`${pluralize(
              TRACKED_KEYWORD,
            )} predictions on feedback older than 1st April, 2023 might not have associated categories.`}
            arrow
          >
            <InfoOutlinedIcon
              sx={{
                color: 'text.secondary',
                fontSize: '16px',
              }}
            />
          </Tooltip>
        )}
      </Stack>
      <Stack direction="row" spacing={0.5}>
        {renderFeedbackLabelList({ isEditPredictionsMode })}
      </Stack>
    </Stack>
  );
};
